export const HIDDEN_TASKS_DICTIONARY = [
  'Pack room X',
  'Pack room (room name)',
  'Catalogue my things',
  'Complete my profile',
];

export const HIDDEN_AGENT_RECOMMENDATION_DICTIONARY = ['Add my favourite service providers'];
